export default "__VITE_ASSET__CFKnP56s__"